import { useSelector } from 'react-redux'
import { audioSelectors } from 'store/features/audio/selectors'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { isAudioFromGenres } from 'utils/audio'

export const useSelectedLibSoundVersionsSelectorState = () => {
  const activeAudio = useSelector(projectDataSelectors.activeAudio)
  const usedLibSoundsMapTable = useSelector(
    audioSelectors.usedLibSoundsMapTable
  )

  const isVersioningAvailable = activeAudio && isAudioFromGenres(activeAudio)

  const selectedLibSoundVersions = !isVersioningAvailable
    ? []
    : usedLibSoundsMapTable[activeAudio?.title] || []

  return {
    selectedLibSoundVersions,
    hasSelectedLibSoundVersion: !!selectedLibSoundVersions.length
  }
}
